"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.logUncaughtErrors = void 0;
const uriHelpers_1 = require("./uriHelpers");
const logUncaughtErrors = (error, info, env) => {
    if (env !== uriHelpers_1.Env.Prod) {
        console.log('Error in AskemSurveyWrapper (from @indeed/smb-askem-askem-surveys)', error, info);
    }
};
exports.logUncaughtErrors = logUncaughtErrors;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiTG9nVW5jYXVnaHRFcnJvcnMuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvdXRpbHMvTG9nVW5jYXVnaHRFcnJvcnMudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUNBLDZDQUFtQztBQUU1QixNQUFNLGlCQUFpQixHQUFHLENBQUMsS0FBWSxFQUFFLElBQWUsRUFBRSxHQUFRLEVBQVEsRUFBRTtJQUMvRSxJQUFJLEdBQUcsS0FBSyxnQkFBRyxDQUFDLElBQUksRUFBRTtRQUNsQixPQUFPLENBQUMsR0FBRyxDQUNQLG9FQUFvRSxFQUNwRSxLQUFLLEVBQ0wsSUFBSSxDQUNQLENBQUM7S0FDTDtBQUNMLENBQUMsQ0FBQztBQVJXLFFBQUEsaUJBQWlCLHFCQVE1QiJ9